import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
import { SERVICES } from '../../lib/constants';
import type { Service } from '../../lib/constants';
function ServiceCard({
  svc,
  index
}: {
  svc: Service;
  index: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.45,
    delay: index * 0.06
  }} className="group relative flex h-full flex-col overflow-hidden rounded-card border border-border bg-white shadow-sm transition-all duration-300 ease-smooth hover:-translate-y-1.5 hover:shadow-lg" data-id="element-452">
      {/* top accent rule */}
      <div className="h-1.5 w-full" style={{
      background: svc.accent
    }} aria-hidden data-id="element-453" />
      {/* hover glow edge */}
      <div className="pointer-events-none absolute inset-0 rounded-card opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
      boxShadow: `inset 0 0 0 1.5px ${svc.accent}`
    }} aria-hidden data-id="element-454" />
      <div className="flex flex-1 flex-col p-6 md:p-8" data-id="element-455">
        <div className="flex h-[84px] items-center rounded-2xl px-5 ring-1" style={{
        background: svc.tintClass,
        borderColor: 'transparent',
        boxShadow: `inset 0 0 0 1px ${svc.accent}18`
      }} data-id="element-456">
          <img src={svc.logo} alt={`CT Group ${svc.name} logo`} className="h-10 w-auto md:h-11" loading="lazy" data-id="element-457" />
        </div>

        <p className="mt-6 text-[15px] leading-relaxed text-slate md:text-[16px]" data-id="element-458">
          {svc.copy}
        </p>

        <ul className="mt-6 space-y-3" data-id="element-459">
          {svc.features.map(f => <li key={f.label} className="flex items-center gap-3 text-[14.5px] font-medium text-ink" data-id="element-460">
              <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg" style={{
            background: svc.tintClass
          }} data-id="element-461">
                <Check className="h-4 w-4" style={{
              color: svc.accent
            }} aria-hidden data-id="element-462" />
              </span>
              {f.label}
            </li>)}
        </ul>

        <a href="#" className="mt-auto inline-flex items-center gap-1.5 pt-7 text-[15px] font-bold transition-colors" style={{
        color: svc.accent
      }} data-id="element-463">
          {svc.cta}
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden data-id="element-464" />
        </a>
      </div>
    </motion.article>;
}
export function Services() {
  return <Section id="services" className="bg-surface-2" ariaLabel="Services" data-id="element-465">
      <SectionHeading eyebrow="Four services. One accountable partner." title="Everything your firm needs, explained plainly." body="Each service works independently, but the real value comes from managing the environment as one connected system." data-id="element-466" />

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6" data-id="element-467">
        {SERVICES.map((svc, i) => <ServiceCard key={svc.id} svc={svc} index={i} data-id="element-468" />)}
      </div>
    </Section>;
}